// web/src/lib/lessonTypes.js
// Color tokens for barn-defined lesson types.
//
// The API stores a TOKEN ('amber'), never a hex value or a class name, and this
// is where a token becomes actual classes. That indirection is not decoration:
// Tailwind builds its stylesheet by scanning source for literal class strings,
// so `bg-${color}-400` compiles to nothing and renders unstyled. Every class
// below has to appear in full, spelled out, in this file.
//
// Keep in step with:
//   - the CHECK on lesson_types.color in migration 0013
//   - the COLORS array in api/src/routes/lesson-types.ts
// A token missing here falls back to slate rather than rendering bare.

export const COLOR_TOKENS = [
  'emerald',
  'indigo',
  'amber',
  'sky',
  'violet',
  'rose',
  'slate',
];

// `card` is the shift block in the roster grid: a tinted panel you read a name
// off, rather than a chip you read a label off. It needs its own row here for
// the same reason everything else does — Tailwind only sees classes written out
// in full, so it cannot be assembled from the chip classes at runtime.
const STYLES = {
  emerald: { spine: 'bg-emerald-400', dot: 'bg-emerald-500', chip: 'bg-emerald-100 text-emerald-800', card: 'bg-emerald-50 border-emerald-300 text-emerald-900' },
  indigo:  { spine: 'bg-indigo-400',  dot: 'bg-indigo-500',  chip: 'bg-indigo-100 text-indigo-800',   card: 'bg-indigo-50 border-indigo-300 text-indigo-900' },
  amber:   { spine: 'bg-amber-400',   dot: 'bg-amber-500',   chip: 'bg-amber-100 text-amber-800',     card: 'bg-amber-50 border-amber-300 text-amber-900' },
  sky:     { spine: 'bg-sky-400',     dot: 'bg-sky-500',     chip: 'bg-sky-100 text-sky-800',         card: 'bg-sky-50 border-sky-300 text-sky-900' },
  violet:  { spine: 'bg-violet-400',  dot: 'bg-violet-500',  chip: 'bg-violet-100 text-violet-800',   card: 'bg-violet-50 border-violet-300 text-violet-900' },
  rose:    { spine: 'bg-rose-400',    dot: 'bg-rose-500',    chip: 'bg-rose-100 text-rose-800',       card: 'bg-rose-50 border-rose-300 text-rose-900' },
  slate:   { spine: 'bg-slate-400',   dot: 'bg-slate-500',   chip: 'bg-slate-100 text-slate-700',     card: 'bg-slate-50 border-slate-300 text-slate-900' },
};

const FALLBACK = STYLES.slate;

/** Classes for a color token. `variant` is spine | dot | chip. */
export function colorClass(token, variant = 'spine') {
  return (STYLES[token] ?? FALLBACK)[variant];
}

/** Human label for a token, for the color picker. */
export function colorLabel(token) {
  return token ? token[0].toUpperCase() + token.slice(1) : 'Slate';
}
